import { numberFormat } from '@enity/formatting'
import i18n from '@libs/internationalization'
import { mergeSeries } from '@libs/models/charts/charts'
import { chartFontSizes, formatCurrency } from '@libs/models/formatters'
import type Highcharts from 'highcharts'
import type { ConsumptionType } from '../../interfaces/interfaces'

export type PieChartData = {
	config?: Highcharts.Options;
	title?: string;
	subTitle?: string;
	categories: string[];
	data: [
		{
			name: string;
			y: number;
		},
	][];
	unit: string;
	consumptionType: ConsumptionType;
};

export default ({ config, title, subTitle, data, unit, consumptionType }: PieChartData): Highcharts.Options => {
	const fontSizes = chartFontSizes()
	const defaultConfig = {
		accessibility: {
			point: {
				valueSuffix: '%',
			},
		},
		chart: {
			backgroundColor: 'transparent',
			height: '600px',
			marginLeft: 0,
			marginRight: 0,
			reflow: true,
			spacingLeft: 0,
			spacingRight: 0,
			type: 'pie',
		},
		credits: {
			enabled: false,
		},
		legend: {
			itemStyle: {
				color: '#ffffff',
				fontSize: fontSizes.legend,
				fontWeight: 'regular',
			},
			label: {
				style: {
					color: '#fff',
				},
			},
			labelFormatter: function() {
				// @ts-expect-error
				return `${this.name}: ${consumptionType === 'cost' ? formatCurrency(unit, this.y) : numberFormat(i18n.global.locale, this.y) + ' ' + unit}`
			},
			symbolRadius: 2,
		},
		plotOptions: {
			pie: {
				borderWidth: 0,
				center: ['50%', '90%'],
				dataLabels: {
					enabled: false,
				},
				endAngle: 90,
				showInLegend: true,
				startAngle: -90,
			},
		},
		series: [
			{
				data: [] as PieChartData['data'],
				innerSize: '50%',
				name: 'Energy',
				type: 'pie',
			},
		],
		subtitle: {
			style: {
				color: '#fff',
				fontSize: fontSizes.subtitle,
			},
			text: subTitle,
		},
		title: {
			style: {
				color: '#fff',
				fontSize: fontSizes.title,
			},
			text: title,
		},
		tooltip: {
			enabled: false,
		},
	} as Highcharts.Options

	if (config) mergeSeries(config, defaultConfig as Highcharts.Options, data)

	return defaultConfig as unknown as Highcharts.Options
}
